<div class="auto-plan">
    <div class="auto-plan--search-block" [ngClass]="{'auto-plan--search-block__items' : planesOperations }">
        <div class="container auto-plan--search-block__position" [ngClass]="{'auto-plan--search-block__position__items' : planesOperations }">
            <div class="row">
                <div class="col-12" *ngIf="!planesOperations">
                    <img class="auto-plan--icons__default" src="assets/images/planes/iconos-planes.svg" alt="planes">
                    <sc-title class="auto-plan--title" content="Buscador de pólizas de planes"></sc-title>
                    <p class="auto-plan--subtitle">Encontrá pólizas de autoplanes e imprimí la documentación que necesites.</p>
                </div>
                <div class="col-12" *ngIf="planesOperations">
                    <img class="auto-plan--icons__default desktop-hidden" src="assets/images/planes/iconos-planes.svg" alt="planes">
                    <sc-title type="h3" class="auto-plan--title__minor mobile-hidden" content="Buscador de pólizas de planes"></sc-title>
                    <sc-title class="auto-plan--title desktop-hidden" content="Buscador de pólizas de planes"></sc-title>
                    <img class="auto-plan--icons__minor mobile-hidden" src="assets/images/planes/iconos-planes.svg" alt="planes">
                    <p class="auto-plan--subtitle">Encontrá pólizas de autoplanes e imprimí la documentación que necesites.</p>
                </div>
            </div>
            <div class="row" [formGroup]="planesForm">
                <div class="col-md-3 col-xs-12 mb-1">
                    <sc-select
                        formControlName="documentType" 
                        [items]="documentTypes" 
                        [enableSearch]="true" 
                        id="02" 
                        placeholder="Ingresa una búsqueda" 
                        [hideError]="true">
                    </sc-select>
                </div>
                <div class="col-md-5 col-xs-12">
                    <sc-input 
                        placeholder="{{placeHolder}}" 
                        formControlName="documentNumber" 
                        [errorMessages]="errorMessages">
                    </sc-input>
                </div>
                <div class="col-md-4 col-xs-12">
                    <sc-button 
                        [id]="'buscador_planes'" 
                        type="primary" 
                        (onClick)="onSearchPlans()"
                        [loading]="loadingPlans">
                        Buscar planes
                    </sc-button>
                </div>
            </div>
        </div>
    </div>
    <div class="auto-plan--search-table" *ngIf="planesOperations">
        <div class="container">
            <sc-auto-plan-operations
                [operations]="planesOperations">
            </sc-auto-plan-operations>
        </div>
    </div>
</div>
